import React, { useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons';
import { Card, Space, Button, Table, Col, Row } from 'antd';
import './Emails.css';
import ConfirmationBox from '../ConfirmationBox';


function Emails() {

    const mainHeaderButtons = (
        <Space wrap>
            <Button className='headerButtons' size='small' icon={<DownloadOutlined />}>Download Emails</Button>
        </Space>
    );

    const columns = [
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Date & Time',
            dataIndex: 'dateTime',
            key: 'dateTime',
        },
        {
            title: 'To',
            dataIndex: 'to',
            key: 'to',
        },
        {
            title: 'From',
            dataIndex: 'from',
            key: 'from',
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
        },
    ]

    const data = [
        {
            key: '1',
            status: 'Delivered',
            dateTime: '02/17/2023 10:54 AM',
            to: 'Mesiah Robinson',
            from: 'admin integrity',
            subject: 'Thank you for your inquiry about 1237 NW 98th'
        },
        {
            key: '2',
            status: 'Delivered',
            dateTime: '	02/15/2023 09:12 AM',
            to: 'Mesiah Robinson',
            from: 'admin integrity',
            subject: 'Thank You for Your Inquiry about 343 SE 42nd St.'
        },
        {
            key: '3',
            status: 'Delivered',
            dateTime: '02/14/2023 11:06 PM',
            to: 'Mesiah Robinson',
            from: 'admin integrity',
            subject: 'Thank You for Your Inquiry about 1517 McGregor Dr.'
        },

    ]

    const [showEmailView, setShowEmailView] = useState(false);

    const [emailData, setEmailData] = useState({})

    function handleRowClick(rowIndex){
        setEmailData(data[rowIndex]);
        setShowEmailView(true);
    }


    return (
        <>

            <Card title="Emails" bordered={false} extra={mainHeaderButtons}>

                <Table columns={columns} dataSource={data} onRow={(record, rowIndex) => {
                    return {
                        onClick: (event) => {handleRowClick(rowIndex)}
                    };
                }} />

            </Card>

            <EmailView show={showEmailView} handleClose={(e) => setShowEmailView(e)} data={emailData}/>


        </>
    )
}

export default Emails

function EmailView({ show, handleClose, data}){


    return (
        <>
                {show ? <>
    
                    <ConfirmationBox setIsConfirmationBoxOpen={handleClose}>
    
                        <h2>View Email</h2>
    
                        <Col span={24} style={{marginTop:22}}>
                           
                            <Row><b>To: </b><span style={{marginLeft:2}}> {data.status }</span></Row>
                            <Row><b>Cc: </b><span style={{marginLeft:2}}> {"" }</span></Row>
                            <Row><b>Bcc: </b><span style={{marginLeft:2}}> {"" }</span></Row>
                            <Row><b>From: </b><span style={{marginLeft:2}}> {data.from }</span></Row>
                            <Row><b>Subject: </b><span style={{marginLeft:2}}> {data.subject }</span></Row>
                          
                        </Col>
    
                    </ConfirmationBox>
    
                </> : <></>}
            </>
      )

}